import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import Image from '@base/Image';
import H7 from '@base/H7/H7';
import useDarkModeStatus from '@stores/useDarkModeStatus';
import { getIsDarkModeOn } from '@stores/selectors/darkModeStatusSelectors';
import { getCtaState } from '../utils';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ $color }) => {
    return $color;
  }};
  padding: ${Spacings.SPACING_10} ${Spacings.SPACING_0B};
  text-align: center;
  width: 100%;
  border-radius: ${Spacings.SPACING_1B};
  min-height: ${Spacings.SPACING_8B};
  margin: ${Spacings.SPACING_4B} auto ${Spacings.SPACING_0B};
  h6 {
    margin-left: ${Spacings.SPACING_1B};
  }
`;

const BottomText = styled(H7)``;

const BatchCardFooter = ({ isFeedCard, stateMetaInfo }) => {
  const isDarkModeOn = useDarkModeStatus(getIsDarkModeOn);
  const ctaState = getCtaState(stateMetaInfo, isDarkModeOn);
  if (!ctaState) return null;
  const { icon, text, buttonColor, textColor } = ctaState;
  return (
    <Container $isFeedCard={isFeedCard} $color={buttonColor}>
      {icon && <Image src={icon} alt="icon" width={16} height={16} />}
      {text && <BottomText color={textColor}>{text}</BottomText>}
    </Container>
  );
};

export default BatchCardFooter;
